import { Component, computed, input, signal } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { SkeletonLoaderComponent } from '../../../../shared/components/skeleton-loader/skeleton-loader.component';
import { AnimateOpenDirective } from '../../../../shared/directives/animate-open.directive';

@Component({
  selector: 'app-mmr-faqs',
  imports: [ButtonComponent, SkeletonLoaderComponent, AnimateOpenDirective],
  templateUrl: './mmr-faqs.component.html',
  styleUrl: './mmr-faqs.component.scss',
  host: {
    class: 'p-24 md-p-16',
  },
})
export class MmrFaqsComponent {
  categoryCode = input.required<string>();

  repairerName = input.required<string>();

  openPanels = signal<Record<number, boolean>>({});
  private viewModel = computed(() => {
    let faqs = this.categoryCode() === 'H' ? this.heatingFAQs : this.categoryCode() === 'W' ? this.whiteGoodsFAQs : [];

    faqs = faqs.map((faq) => {
      return {
        ...faq,
        answer: faq.answer.map((ans) => ans.replace(/{{ repairerName }}/g, this.repairerName())),
      };
    });
    return {
      categoryCode: this.categoryCode(),
      openPanels: this.openPanels(),
      questions: faqs,
    };
  });

  get vm() {
    return this.viewModel();
  }

  heatingFAQs = [
    {
      question: 'Can I change my booking on the day of visit?',
      answer: [
        'On the day of your visit or the day before, you’ll need to contact {{ repairerName }} directly. Please use their contact details further up on this page.',
      ],
    },
    {
      question: 'How do I book an annual service?',
      answer: ['Under “Your annual service” on this page above, please select “Book a service”.'],
    },
  ];

  whiteGoodsFAQs = [
    {
      question: 'How do I change my engineer booking?',
      answer: [
        'Up to two days before your appointment, you can use the “Change the date” option above. But on the day of your visit or the day before, you’ll need to contact {{ repairerName }} directly. Please use their contact details further up on this page.',
      ],
    },
    {
      question: 'Can I change my booking on the day of visit?',
      answer: [
        'On the day of your visit or the day before, you’ll need to contact {{ repairerName }} directly. Please use their contact details further up on this page.',
      ],
    },
    {
      question: "What if you can't fix my appliance?",
      answer: [
        'If the engineer decides your product is beyond repair, they’ll let us know.',
        'This can take 48 hours from their final visit to you.',
        'Next, we’ll send you a text or email explaining how to order a replacement.',
        'You’ll be able to choose a replacement with the same or similar specifications as your old one. We might also offer you an upgraded model for an added fee.',
        'Or depending on your plan, we might send you vouchers towards a replacement instead.',
      ],
    },
    {
      question: 'How do I order a replacement?',
      answer: [
        'When you need a replacement, we’ll text or email you with the next steps.',
        'You’ll get either a phone number to call or a link to order online.',
        'The offer won’t expire, so you can order whenever you like. But we update our offers regularly with the latest models, so the products available can change over time.',
        'You might need to pay for delivery, installation and any remaining plan payments. Please check your plan’s terms and conditions for more details.',
      ],
    },
    {
      question: 'How do I cancel a claim?',
      answer: [
        'To cancel, you can use the option “Cancel the repair” further up on this page. But if you just want to reschedule, please select “Change the date” instead.',
      ],
    },
  ];

  updateOpenPanels(index: number): void {
    this.openPanels.update((value) => {
      return {
        ...value,
        [index]: !this.openPanels()[index],
      };
    });
  }
}
